export default "__VITE_ASSET__9c8364fb__"